import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 1. BrowserRouter ko import karein
import { BrowserRouter } from 'react-router-dom';

// enable Tailwind dark class by default for modern dark theme
try { document.documentElement.classList.add('dark'); } catch (e) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();